const errorClass = 'is-invalid';

class FormValidation {
    constructor(form) {
        this.form = form;
    }

    static validation () {
        return {
            required: fieldToCheck => {
                if (typeof fieldToCheck.dataset.requiredIfFilled !== 'undefined') {
                    let allFieldsEmpty = true;

                    fieldToCheck.dataset.requiredIfFilled.split(',').forEach(relatedFieldId => {
                        const relatedField = document.getElementById(relatedFieldId);

                        if (relatedField.tagName.toLowerCase() === 'select') {
                            if (relatedField.options[relatedField.selectedIndex].value !== 'placeholder') {
                                allFieldsEmpty = false;
                            }
                        } else {
                            if (relatedField.value.trim() !== '') {
                                allFieldsEmpty = false;
                            }
                        }
                    });

                    if (allFieldsEmpty) {
                        return true;
                    }
                }

                if (fieldToCheck.tagName.toLowerCase() === 'select') {
                    return !(fieldToCheck.options[fieldToCheck.selectedIndex].value === 'placeholder');
                }

                const val = fieldToCheck.value;
                return !(val.trim() === '');
            },
            email: fieldToCheck => {
                const val = fieldToCheck.value;
                const apos = val.indexOf('@');
                const dotpos = val.lastIndexOf('.');

                return !(apos < 1 || dotpos - apos < 2);
            },
            matchWith: (fieldToCheck, matchWithField) => {
                if (matchWithField === null) {
                    return true;
                }

                return fieldToCheck.value === matchWithField.value;
            },
            changeEvent: evt => {
                const fieldToCheck = evt.currentTarget;
                const fieldToCheckType = fieldToCheck.type;
                let fieldInvalid = true;

                if (this.validation().required(fieldToCheck)) {
                    fieldInvalid = false;

                    switch (fieldToCheckType) {
                        case 'email':
                            fieldInvalid = true;

                            if (this.validation().email(fieldToCheck)) {
                                fieldInvalid = false;
                            }

                            break;
                        default:
                            break;
                    }

                    if (typeof fieldToCheck.dataset.validationMatchWith !== 'undefined') {
                        fieldInvalid = true;
                        const matchWithField = document.querySelector(`[name="${fieldToCheck.dataset.validationMatchWith}"]`);

                        if (this.validation().matchWith(fieldToCheck, matchWithField)) {
                            fieldInvalid = false;
                            matchWithField.removeEventListener('keyup', this.validation().matchWithChangeEvent, false);
                        }
                    }
                }

                if (!fieldInvalid) {
                    if (fieldToCheck.tagName.toLowerCase() === 'select') {
                        fieldToCheck.removeEventListener('change', this.validation().changeEvent, false);
                        fieldToCheck.removeEventListener('changeSelect2', this.validation().changeEvent, false);
                    } else {
                        fieldToCheck.removeEventListener('keyup', this.validation().changeEvent, false);
                        fieldToCheck.removeEventListener('changedBySelect2', this.validation().changeEvent, false);
                    }

                    if (fieldToCheck.classList.contains(errorClass)) {
                        fieldToCheck.classList.remove(errorClass);
                    }
                }
            },
            matchWithChangeEvent: evt => {
                const fieldToCheck = evt.currentTarget;
                const matchWithField = document.querySelector(`[data-validation-match-with="${fieldToCheck.name}"]`);

                if (this.validation().matchWith(fieldToCheck, matchWithField)) {
                    fieldToCheck.removeEventListener('keyup', this.validation().matchWithChangeEvent, false);
                    matchWithField.removeEventListener('keyup', this.validation().changeEvent, false);

                    if (matchWithField.classList.contains(errorClass)) {
                        matchWithField.classList.remove(errorClass);
                    }
                }
            }
        };
    };

    static validateForm(form) {
        form.addEventListener('submit', evt => {
            evt.stopPropagation();
            evt.preventDefault();
            const requiredElems = form.querySelectorAll('[required]:not(.d-none), [data-required-if-filled]:not(.d-none)');

            if (requiredElems.length === 0) {
                form.submit();
            }

            let invalid = false;

            requiredElems.forEach(requiredElem => {
                const elemType = requiredElem.type;
                let fieldInvalid = false;

                if (requiredElem.classList.contains(errorClass)) {
                    requiredElem.classList.remove(errorClass);
                }

                if (!this.validation().required(requiredElem)) {
                    invalid = true;
                    fieldInvalid = true;
                } else {
                    switch (elemType) {
                        case 'email':
                            if (!this.validation().email(requiredElem)) {
                                invalid = true;
                                fieldInvalid = true;
                            }

                            break;
                        default:
                            break;
                    }

                    if (typeof requiredElem.dataset.validationMatchWith !== 'undefined') {
                        const matchWithField = document.querySelector(`[name="${requiredElem.dataset.validationMatchWith}"]`);

                        if (!this.validation().matchWith(requiredElem, matchWithField)) {
                            invalid = true;
                            fieldInvalid = true;
                            matchWithField.removeEventListener('keyup', this.validation().matchWithChangeEvent, false);
                            matchWithField.addEventListener('keyup', this.validation().matchWithChangeEvent, false);
                        }
                    }
                }

                if (fieldInvalid) {
                    if (requiredElem.tagName.toLowerCase() === 'select') {
                        requiredElem.removeEventListener('change', this.validation().changeEvent, false);
                        requiredElem.addEventListener('change', this.validation().changeEvent, false);

                        if (requiredElem.classList.contains('select2-hidden-accessible')) {
                            requiredElem.removeEventListener('changeSelect2', this.validation().changeEvent, false);
                            requiredElem.addEventListener('changeSelect2', this.validation().changeEvent, false);
                        }
                    } else {
                        requiredElem.removeEventListener('keyup', this.validation().changeEvent, false);
                        requiredElem.addEventListener('keyup', this.validation().changeEvent, false);

                        if (typeof requiredElem.dataset.filledBySelectTwo !== 'undefined') {
                            requiredElem.removeEventListener('changedBySelect2', this.validation().changeEvent, false);
                            requiredElem.addEventListener('changedBySelect2', this.validation().changeEvent, false);
                        }
                    }

                    if (!requiredElem.classList.contains(errorClass)) {
                        requiredElem.classList.add(errorClass);
                    }
                }
            });

            if (!invalid) {
                form.submit();
            }
        });
    }

    init() {
        this.constructor.validateForm(this.form);
    }
}

export default FormValidation
